import { IInitialState } from 'store/models';
import { stateSelector } from '../stateSelector';

export function surveysStateSelector(state: IInitialState) {
	return stateSelector(state).surveys;
}
